import { render, staticRenderFns } from "./BrowserBlocked.vue?vue&type=template&id=74bfb628&scoped=true&"
var script = {}
import style0 from "./BrowserBlocked.vue?vue&type=style&index=0&id=74bfb628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bfb628",
  null
  
)

export default component.exports